import {
  GET_CONTACT_US_FAILURE,
  GET_CONTACT_US_REQUEST,
  GET_CONTACT_US_SUCCESS,
  UPDATE_ANSWER_CONTACT_US_FAILURE,
  UPDATE_ANSWER_CONTACT_US_REQUEST,
  UPDATE_ANSWER_CONTACT_US_SUCCESS,
} from "./actionTypes";

const initialState = {
  error: false,
  loading: false,
  data: null,
  success: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTACT_US_REQUEST:
      console.log("REQUEST");
      state = {
        ...state,
        data: {},
        loading: true,
        error: false,
      };
      break;

    case GET_CONTACT_US_SUCCESS:
      console.log("SUCCESS");
      state = {
        ...state,
        data: action.data,
        error: false,
        loading: false,
      };
      break;

    case GET_CONTACT_US_FAILURE:
      console.log("FAILURE");
      state = {
        ...state,
        data: {},
        loading: false,
        error: true,
      };
      break;

    case UPDATE_ANSWER_CONTACT_US_REQUEST:
      console.log("REQUEST");
      state = {
        ...state,
        data: {},
        loading: true,
        error: false,
        success: false,
      };
      break;

    case UPDATE_ANSWER_CONTACT_US_SUCCESS:
      console.log("SUCCESS");
      state = {
        ...state,
        data: action.data,
        error: false,
        loading: false,
        success: true,
      };
      break;

    case UPDATE_ANSWER_CONTACT_US_FAILURE:
      console.log("FAILURE");
      state = {
        ...state,
        data: {},
        loading: false,
        error: true,
        success: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default reducer;
